import { render, staticRenderFns } from "./ContributorPage.vue?vue&type=template&id=600729c8"
import script from "./ContributorPage.vue?vue&type=script&lang=js"
export * from "./ContributorPage.vue?vue&type=script&lang=js"
import style0 from "./ContributorPage.vue?vue&type=style&index=0&id=600729c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports